<div class="container flex-direction-column">
  <div class="d-flex align-items-center c-pointer" (click)="dropInput.click()">
    <mat-icon class="material-symbols-outlined">attach_file</mat-icon>
    <span class="ml-4">{{ config.label }}</span>
  </div>
  <input
    hidden
    type="file"
    #dropInput
    name="file"
    multiple
    [accept]="config.availableFileTypes || defaultFileTypes"
    (change)="onAddFile($event.target.files)"
    (click)="dropInput.value = null"
  />
  <div class="file-list d-flex flex-direction-column">
    <div class="file-item mt-8 d-flex justify-content-between" *ngFor="let item of files; let i = index">
      <div class="d-flex align-items-center">
        <fb-format-file-icon [format]="item.type | formatFileFromFileTypePipe"></fb-format-file-icon>
        <span
          class="file-name ml-12"
          [class.dark-theme-color]="(_currentThemeSubject | async) === 'dark'"
          [class.light-theme-color]="(_currentThemeSubject | async) === 'light'"
          >{{ item.name }}</span
        >
      </div>
      <mat-icon fontSet="material-symbols-outlined" class="icon-button c-pointer" (click)="onDeleteFromList(i)"
        >delete</mat-icon
      >
    </div>
  </div>
</div>
